module.exports = __webpack_public_path__ + "static/img/200047.4f1cdfb1.png";